import settings from "@settings";
import React from "react";
import { FullButton } from "../Button";
import { navigate } from "gatsby";
import { sportBannerContainer } from "./styles";

const SportBanner: React.FC = () => (
  <div css={sportBannerContainer}>
    <div css={settings.mq({ flex: 1 })}>
      <h2
        css={{
          color: `${settings.colors.light} !important`,
          fontSize: "3em",
          textTransform: "uppercase",
          textAlign: "left",
        }}
      >
        Finde jetzt Deine nächste Sportart!
      </h2>
    </div>
    <div
      css={settings.mq({
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "1em",
        flexWrap: "wrap",
        paddingLeft: [0, "1em", "2em", "3em", "4em"],
      })}
    >
      <FullButton
        color="white"
        text="Ballsport"
        onClick={() => navigate("/sportarten/ballsport")}
      />
      <FullButton
        color="white"
        text="Gesundheitssport"
        onClick={() => navigate("/sportarten/gesundheitssport")}
      />
      <FullButton
        color="white"
        text="Tanz und Rope Skipping"
        onClick={() => navigate("/sportarten/tanz-und-rope-skipping")}
      />
      <FullButton
        color="white"
        text="Turnen"
        onClick={() => navigate("/sportarten/turnen")}
      />
      <FullButton
        color="white"
        text="Leichtathletik"
        onClick={() => navigate("/sportarten/leichtathletik")}
      />
    </div>
  </div>
);

export default SportBanner;
